import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { TutorialProvider } from "./components/TutorialProvider";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import ServiceDetail from "./pages/ServiceDetail";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminQuotes from "./pages/AdminQuotes";
import AdminQuoteDetail from "./pages/AdminQuoteDetail";
import AdminUsers from "./pages/AdminUsers";
import AdminMailing from "./pages/AdminMailing";
import AdminHourlyRates from "./pages/AdminHourlyRates";
import AdminQuoteDrafts from "./pages/AdminQuoteDrafts";
import AdminQuoteDraftDetail from "./pages/AdminQuoteDraftDetail";
import Jobs from "./pages/Jobs";
import Calendar from "./pages/Calendar";
import { JobDetail, ReportDetail } from "./pages/Reports";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ChangePassword from "./pages/ChangePassword";
import { ForgotPassword, ResetPassword } from "./pages/PasswordReset";
import AuthCallback from "./pages/AuthCallback";
import AdminFurgoni from "./pages/AdminFurgoni";
import AdminCatalog from "./pages/AdminCatalog";
import AdminOffers from "./pages/AdminOffers";
import AdminNotifications from "./pages/AdminNotifications";
import TabletEntry from "./pages/TabletEntry";
import TabletHome from "./pages/TabletHome";
import TabletPin from "./pages/TabletPin";
import MobileEntry from "./pages/MobileEntry";
import PushPermissionBanner from "./components/PushPermissionBanner";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth session_id in URL fragment - process BEFORE any route matching
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/servizi/:slug" element={<ServiceDetail />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/dashboard" element={<UserDashboard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/preventivi" element={<AdminQuotes />} />
      <Route path="/admin/preventivi/:id" element={<AdminQuoteDetail />} />
      <Route path="/admin/utenti" element={<AdminUsers />} />
      <Route path="/admin/mailing" element={<AdminMailing />} />
      <Route path="/admin/tariffe" element={<AdminHourlyRates />} />
      <Route path="/admin/preventivi-staff" element={<AdminQuoteDrafts />} />
      <Route path="/admin/preventivi-staff/:id" element={<AdminQuoteDraftDetail />} />
      <Route path="/lavori" element={<Jobs />} />
      <Route path="/calendario" element={<Calendar />} />
      <Route path="/lavori/:id" element={<JobDetail />} />
      <Route path="/relazioni/:id" element={<ReportDetail />} />
      <Route path="/admin/furgoni" element={<AdminFurgoni />} />
      <Route path="/admin/catalogo-materiali" element={<AdminCatalog />} />
      <Route path="/admin/offerte" element={<AdminOffers />} />
      <Route path="/admin/notifiche" element={<AdminNotifications />} />
      <Route path="/tablet" element={<TabletEntry />} />
      <Route path="/tablet/home" element={<TabletHome />} />
      <Route path="/tablet/pin/:userId" element={<TabletPin />} />
      <Route path="/mobile" element={<MobileEntry />} />
      <Route path="/profile" element={<Profile />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <TutorialProvider>
            <AppRouter />
            <PushPermissionBanner />
          </TutorialProvider>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
